import antology1 from '../../../media/experience/antology/1756836081233.jpg';
import antology2 from '../../../media/experience/antology/Homepage.png';
import antology3 from '../../../media/experience/antology/screenshot2.png';
import antology4 from '../../../media/experience/antology/screenshot1.png';
import sampleOutput from '../../../media/experience/antology/Meetings_analysis_report_2025-11-24.pdf';
import antologyPoster from '../../../media/experience/antology/AntologyIcon.jpeg';

const antologyData = {
  company: "Antology",
  slug: "antology",
  poster: antologyPoster,
  location: "New York, NY",
  heroImage: antology1,

  roles: [
    {
      title: "Software Engineer",
      start: "May 2025",
      end: "December 2025",
      summary: "At Antology, I built a data platform from scratch that reverse-engineered core Palantir Foundry patterns on a custom stack: mapping schemas from PostgreSQL, MySQL, and other sources onto shared business objects and link types to create a unified source of truth. ML agents profiled schemas, inferred relationships between tables, and produced Workshop-style reports and recommendations. I built the full stack in React and FastAPI with Firebase for auth and live updates, PySpark-style ingestion pipelines, and MCP for agent orchestration and production LLM queries; async workers and caching kept large database scans from bogging down the API.",
    },
  ],

  techStack: [
    "React",
    "FastAPI",
    "Python",
    "TypeScript",
    "PostgreSQL",
    "MySQL",
    "Object/link-type modeling",
    "SSOT / unified analytics",
    "PySpark-style pipelines",
    "MCP",
    "LLM Agents",
    "Firebase",
    "REST APIs",
    "Machine Learning",
    "Tailwind CSS"
  ],

  gallery: [
    { type: 'image', src: antology2, alt: 'Antology platform homepage and dashboard' },
    { type: 'image', src: antology3, alt: 'Database analysis interface' },
    { type: 'image', src: antology4, alt: 'AI-powered insights and recommendations' },
    { type: 'image', src: antology1, alt: 'Working on Antology development' }
  ],

  documents: [
    { type: 'pdf', src: sampleOutput, alt: 'Sample AI-generated meeting analysis report', title: 'View Sample Output' }
  ],
  documentTitle: "Sample Output",

  links: {
    company: "https://antology.io",
    linkedin: "https://www.linkedin.com/company/antologyio/"
  }
};

export default antologyData;
